import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import AddOrgSurvey from '../../AddOrgSurvey/index';
import { formatDateDefault } from 'services/DateFormatters';

class OrgSurveyRow extends React.Component {

    onOrgSurveyOptionToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };
    onOrgSurveyClose = () => {
        this.setState({ addOrgSurveyState: false });
    };
    onEditOrgSurvey = () => {
        this.setState({ menuState: false, addOrgSurveyState: true });
    };

    constructor() {
        super();
        this.state = {
            menuState: false,
            addOrgSurveyState: false,
        };
    }

    render() {
        const { selectedOrgSurvey, surveys, onSaveOrgSurvey, showOrgSurveyLoader } = this.props;
        const { menuState, addOrgSurveyState } = this.state;
        const { name, startDate, endDate } = selectedOrgSurvey;
        const options = [
            'Edit'
        ];
        return (
            <div className="contact-item">
                <div className="col">
                    <p className="mb-0">
                        <span className="contact-name">
                            {name}
                        </span>
                    </p>
                    <div className="text-muted">
                        <span className="email d-inline-block mr-2">
                            Start Date - {formatDateDefault(startDate)}
                        </span>
                        <span className="d-inline-block toolbar-separator">&nbsp;</span>
                        <span className="phone d-inline-block">
                            End Date - {formatDateDefault(endDate)}
                        </span>
                    </div>
                </div>

                <div className="col-auto px-1 actions d-sm-flex">
                    <Dropdown isOpen={menuState}
                        toggle={this.onOrgSurveyOptionToggle.bind(this)}>
                        <DropdownToggle tag="span">
                            <span className="icon-btn text-grey pointer">
                                <i className="zmdi zmdi-more-vert zmdi-hc-lg" />
                            </span>
                        </DropdownToggle>
                        <DropdownMenu>
                            {options.map(option =>
                                <DropdownItem key={option} 
                                    onClick={() => {
                                        if (option === 'Edit') {
                                            this.onEditOrgSurvey();
                                        }
                                    }
                                }>
                                    {option}
                                </DropdownItem>,
                            )}
                        </DropdownMenu>
                    </Dropdown>
                    {addOrgSurveyState &&
                        <AddOrgSurvey
                            surveys={surveys}
                            open={addOrgSurveyState}
                            orgSurvey={selectedOrgSurvey}
                            onSaveOrgSurvey={onSaveOrgSurvey}
                            onOrgSurveyClose={this.onOrgSurveyClose}
                            showOrgSurveyLoader={showOrgSurveyLoader}
                        />
                    }
                </div>
            </div>
        );
    }
}

export default OrgSurveyRow;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurvey/OrgSurveyList/OrgSurveyRow/index.js